import React from 'react'
import { translate } from 'react-i18next'
import { compose, pure } from 'recompose'
import { NavLink } from 'react-router-dom'
import styles from './footerComponent.scss'
import SmartTOSLink from '../../containers/tosLink/tosLinkContainer'
import SmartPrivacyLink from '../../containers/privacyLink/privacyLinkContainer'
import ContentContainer from '../contentContainer/contentContainerComponent'
import TwitterIcon from '../../assets/icons/twitter.svg'
import FacebookIcon from '../../assets/icons/facebook.svg'
import InstaIcon from '../../assets/icons/instagram.svg'
import PropTypes from 'prop-types'
import LoadingSpinner from '../loadingSpinner/loadingSpinnerComponent'
import TxLogo from '../../assets/icons/txocLogoHorizontal.svg'

export function Footer (props: Props) {
  const { t } = props
  return (
    <footer className={styles.appFooter}>
      <ContentContainer className={styles.footerContentRow}>
        <div className={styles.column}>
          <a
            className={styles.footerLogo}
            href='https://texasoncourse.org/'
            target='_blank'
            rel='noopener noreferrer'>
            <TxLogo />
          </a>
          <nav>
            <ul className={styles.footerNavMenu}>
              <li>
                <small>
                  <SmartTOSLink className={styles.footerNavLink} />
                </small>
              </li>
              <li>
                <small>
                  <a href='mailto:TexasOnCourseSupport@highered.texas.gov?subject=MapMyGrad Support Request'
                    target='_blank'
                    className={styles.footerNavLink}>{t('nav:support')}</a>
                </small>
              </li>
              <li>
                <small>
                  <a
                    href='https://www.middlegalaxy.org/'
                    className={styles.footerNavLink}
                    target='_blank'
                  >
                    {t('career:middleGalaxy')}
                  </a>
                </small>
              </li>
            </ul>
          </nav>
        </div>
        <div className={styles.socialRow}>
          <a
            href='http://www.instagram.com/mapmygrad'
            target='_blank'
            rel='noopener noreferrer'
            aria-label='Instagram'
          >
            <InstaIcon />
          </a>
          <a
            href='https://twitter.com/texasoncourse'
            target='_blank'
            rel='noopener noreferrer'
            aria-label='Twitter'
          >
            <TwitterIcon />
          </a>
          <a
            href='https://www.facebook.com/texasoncourse'
            target='_blank'
            rel='noopener noreferrer'
            aria-label='Facebook'
          >
            <FacebookIcon />
          </a>
        </div>
      </ContentContainer>
    </footer>
  )
}
Footer.propTypes = {
  t: PropTypes.func.isRequired
}

export default compose(pure, translate())(Footer)



// WEBPACK FOOTER //
// ./src/components/footer/footerComponent.js